/* eslint-disable max-len */
const React = require('react')
const PropTypes = require('prop-types')
const { ProComponent } = require('component/viewer/pro')

const withStyles = require('withStyles').default
const styles = require('./footer.less')

function Footer(props) {

    return (
        <footer>
            <div className="structure">
                <div className="sections">
                    <section>
                        <h2>Product</h2>
                        <div className="links">
                            <p><a href="/features">Features</a></p>
                            <p><a href="/pricing">Pricing</a></p>
                            <p><a href="/emailsignature">Email Signature</a></p>
                            <p><a href="/side-hustlers">Side Hustlers</a></p>
                            <p><a href="/virtualtwin">AI Virtual Twin</a></p>
                        </div>
                    </section>
                    <section>
                        <h2>Company</h2>
                        <div className="links">
                            {/* <p><a href="https://blog.about.me">Blog</a></p> */}
                            <p><a href="/press">Press</a></p>
                            <p><a href="/privacy">Privacy Policy</a></p>
                            <p><a href="/legal">Legal</a></p>
                        </div>
                    </section>
                    <ProComponent>
                        <section>
                            <h2>Support</h2>
                            <div className="links">
                                <p><a href="https://support.about.me" target="_blank" rel="noopener noreferrer">Help & Education</a></p>
                                <p><a href="mailto:support@team.about.me" target="_blank" rel="noopener noreferrer">Contact Support</a></p>
                            </div>
                        </section>
                    </ProComponent>
                </div>
                <section className="bottom-row">
                    <p>
                        <span className="copyright">© {(new Date()).getFullYear()} about.me<span className="trademark">™</span></span>
                        <a href="https://twitter.com/aboutdotme" className="glyph-twitter glyph-center" title="Follow us on Twitter">&nbsp;</a>
                        {/* <a href="https://medium.com/@aboutdotme" className="glyph-medium glyph-center" title="Follow us on Medium">&nbsp;</a> */}
                    </p>
                </section>
            </div>

        </footer>
    )

}

Footer.propTypes = {
    showBadges: PropTypes.bool,
}

Footer.defaultProps = {
    showBadges: false,
}

module.exports = withStyles(styles)(Footer)
